import HTTP from "../helpers/ApiClient";

export const LOAD_PRODUCTS = process.env.REACT_APP_LOAD_PRODUCTS.split(",");

export const getBuyLoadPartnerList = async () => {
	try {
		const response = await HTTP.get("/v2/buyload");
		const partnerData = response?.data.data;
		const sortedList = partnerData.sort((a, b) =>
			a.name.localeCompare(b.name)
		);
		return { status: true, data: sortedList };
	} catch (error) {
		console.error("Error fetching users:", error);
		return { status: false, data: error };
	}
};

export const getBuyLoadPartnerForm = async (partnerCode, isServiceFeeExist) => {
	const promises = [];

	const partnerInfoPromise = HTTP.get(`/v2/buyload/${partnerCode}`);
	promises.push(partnerInfoPromise);
	let partnerServiceFeePromise = null;
	if (!isServiceFeeExist) {
		partnerServiceFeePromise = HTTP.get(`/v2/buyload/${partnerCode}/fees`);
		promises.push(partnerServiceFeePromise);
	}

	const response = await Promise.allSettled(promises);
	const storeServiceFeeData = [];
	if (isServiceFeeExist == false) {
		response[0].value.data.data["otherCharges"] =
			response[1].status === "fulfilled"
				? response[1].value.data.data.otherCharges
				: "0.00";
		let { code } = response[0].value.data.data;
		const feeResponseStatusCode = response[1].status;
		let isRegular = 0;
		let otherCharges = 0.0;
		let isRequestSuccessful;
		if (
			response[1].status !== "rejected" &&
			response[1].value.data.data &&
			response[1].value.data.data.length !== 0
		) {
			const data = response[1].value.data.data;
			if (
				data.otherCharges.trim() !== "" &&
				!isNaN(parseFloat(data.otherCharges)) &&
				isFinite(data.otherCharges)
			) {
				otherCharges = response[0].value.data.data.otherCharges;
				isRegular = 1;
				isRequestSuccessful = true;
			}
			// handler for custom billers returning otherCharges:NaN value
			else if (data.otherCharges == "NaN") {
				isRequestSuccessful = true;
			}
		}

		if (feeResponseStatusCode == "rejected") {
			const errorCode = response[1].reason.response.status;
			otherCharges = 0.0;
			isRegular = 0;
			isRequestSuccessful = errorCode == 422 ? true : false;
		}

		storeServiceFeeData.push(code);
		storeServiceFeeData.push(otherCharges);
		storeServiceFeeData.push(isRegular);
		storeServiceFeeData.push(isRequestSuccessful);
	}

	if (response[0].status === "fulfilled") {
		return {
			status: true,
			formData: response[0].value.data,
			feesData: storeServiceFeeData,
		};
	} else {
		return {
			status: false,
			formData: [],
			feesData: [],
		};
	}
};

export const getBuyLoadCategoryList = async (partnerCode) => {
	try {
		const response = await HTTP.get(
			`/v2/buyload/cws/categories?partner_id=${partnerCode}`
		);
		const categories = response?.data?.categories;
		const categoryOptions = categories.reduce((acc, category) => {
			const key = `${category.id}_${category.category_type}`;
			acc[key] = category.name;
			return acc;
		}, {});

		const catData = {
			0: "Select Load Category",
			...categoryOptions,
		};
		return { status: true, data: catData };
	} catch (error) {
		console.error("Error fetching users:", error);
		return { status: false, data: error };
	}
};

export const getLoadList = async (partnerCode, id) => {
	try {
		const [catId, catType] = id.split("_");
		if (catId == 0 || catId == "0") {
			let promoData = {
				0: "Select Load Promo",
			};
			return { status: true, data: promoData };
		} else {
			const response = await HTTP.get(
				`/v2/buyload/cws/sku?partner_id=${partnerCode}&category_id=${catId}`
			);
			const promos = response?.data?.promos;
			if (promos.length > 0) {
				const promoOptions = promos.reduce((acc, promo) => {
					let sku = promo.sku !== null ? promo.sku : 0;
					const key = `${promo.id}_${promo.price}_${sku}`;
					acc[key] = promo.title;
					return acc;
				}, {});

				let promoData = {
					0: "Select Load Promo",
					...promoOptions,
				};
				return { status: true, data: promoData };
			} else {
				let promoData = {
					0: "Select Load Promo",
				};
				return { status: true, data: promoData };
			}
		}
	} catch (error) {
		let promoData = {
			0: "Select Load Promo",
		};
		console.error("Error fetching users:", error);
		return { status: false, data: promoData };
	}
};
